import React, { useState, useEffect, useContext } from "react";
import { LuEye, LuTrash2, LuPencil } from "react-icons/lu";
import { TbUser, TbCalendarUser } from "react-icons/tb";
import { HiOutlineEnvelope } from "react-icons/hi2";
import dummy from '../../../assets/images/user.png';
import { GrUserSettings } from "react-icons/gr";
import { LiaUserClockSolid } from "react-icons/lia";
import '../settings.scss';
import apiService from "../../../services/apiService"; 
import masterApi from "../../../services/masterApi"; 

export const ProfileDetails = ({ closePopup }) => {

  const [userDetails, setUserDetails] = useState(null);
  const [designation, setDesignation] = useState(null);
  const [role, setRole] = useState(null);
  const [createdDate, setCreatedDate] = useState(null);
  
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const userData = JSON.parse(localStorage.getItem('user'));
    if (userData) {
      setUserDetails(userData);
      if (userData?.designationId) {
        const designationData = await apiService.getActiveDesignations();
        setDesignation(designationData.find(d => parseInt(d.DesignationId) === parseInt(userData.designationId)));
      }
      const response = await masterApi.getRoleById(userData.roleId);
      if (response.data) {
        setRole(response.data.role);
        setCreatedDate(response.data.role.createdAt.split('T')[0]);
      }
      
      console.log(role);
    }
  };



  return (
    <div className="card p-3 mb-4 profile-wrapper">
      <div className="d-flex gap-3 align-items-center mb-3">
        <h5 className="mb-0">Profile Details</h5>
        <button
          type="button"
          className="ms-auto btn plain-btn-primary view-btn primary-color"
          title="Edit Profile"
        // onClick={() => handleEditClick(row)}
        >
          <LuPencil />
        </button>
      </div>
      <div className="name-dp-info d-flex gap-4 mb-4">
        <div className="dp-holder position-relative d-flex align-items-center">
          {/* Show default icon if there are no dp */}
          {/* <span><TbUser /></span> */}
          {/* Show uploaded image preview */}
          <img src={dummy} alt="ZeaRecruit" />
          <span className="featured"></span>
        </div>

        <div className="right-info">
          <h6 className="mb-1">{userDetails?.firstName} {userDetails?.lastName} </h6>
          <p className="mb-3">{designation?.DesignationTitle}</p>
          <div className="d-flex gap-5 mb-3 list-about align-items-center">
            <div className="d-flex gap-2 align-items-center" title="role">
              <span><GrUserSettings /></span>
              <p className="mb-0">
                {role?.roleName}
              </p>
            </div>
            <div className="d-flex gap-2 align-items-center" title="role">
              <span><HiOutlineEnvelope /></span>
              <p className="mb-0">
                {userDetails?.email}
              </p>
            </div>
            <div className="d-flex gap-2 align-items-center" title="role">
              <span><LiaUserClockSolid /></span>
              <p className="mb-0">
                Full-TIme
              </p>
            </div>
            <div className="d-flex gap-2 align-items-center" title="role">
              <span><TbCalendarUser /></span>
              <p className="mb-0">
                {createdDate}
              </p>
            </div>
          </div>
          {/* <p className="mb-0">
            Reference Point
            <span className="count">150</span>
          </p> */}


        </div>
      </div>
    </div>
  );
};
